// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/fonts/SF-Pro-Display-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/assets/fonts/SF-Pro-Display-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/assets/fonts/SF-Pro-Display-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/assets/fonts/Roboto-Italic-VariableFont_wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts */

@font-face {
    font-family: "SF Pro Display";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: "SF Pro Display";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("opentype");
    font-weight: 600;
    font-style: normal;
}

@font-face {
    font-family: "SF Pro Display";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("opentype");
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: "Roboto";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("ttf");
    font-weight: 500;
    font-style: normal;
}

/* Fonts */

/* Background */

.background {
    z-index: -1;
    position: absolute;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
}

/* Background */

/* Main style */

body, *{
  font-family: SF Pro Display, sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#root {
  max-height: 100vh;
  overflow: hidden;
}


.default-page-setting {
  width: 100vw;
  height: 100vh;
  padding-top: 18.5vw;
  padding-bottom: 24vw;
}

h1 {
    font-weight: 600;
    font-size: 11.163vw;
    line-height: 13.256vw;
    text-align: center;
    color: white;
}

h3 {
    font-weight: 500;
    font-size: 4.651vw;
    line-height: 5.349vw;
    letter-spacing: 2%;
    color: #FFFFFF;
}

h4 {
    font-weight: 300;
    font-size: 3.721vw;
    line-height: 4.186vw;
    letter-spacing: 2%;
    text-align: center;
    color: #FFFFFF66;
}

h5 {
    font-weight: 400;
    font-size: 3.256vw;
    line-height: 3.886vw;
    letter-spacing: 2%;
    color: #FFFFFF66;
}

.stars-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.top-margin {
    margin-top: 13.953vw;
}

/* Main style */

/* Bottom nav bar */

.bottom-nav-bar {
    display: flex;
    position: absolute;
    left: 6.977vw;
    bottom: 6.977vw;
    width: 86.512vw;
    border-radius: 16px;
    border: 1px solid #FFFFFF1C;
    backdrop-filter: blur(59px);
    background-color: #49B2FF0D;
}

.bottom-nav-bar .navbar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 28.837vw;
    height: 16.977vw;
    text-decoration: none
}

.bottom-nav-bar .navbar-item:nth-child(-n+2) {
    border-right: 1px solid #FFFFFF1C;
}

.navbar-item .navbar-icon{
    width: 6.512vw;
    height: 6.512vw;
    margin-bottom: 0.93vw;
}

.navbar-item p {
    font-weight: 600;
    font-size: 2.791vw;
    line-height: 3.33vw;
    letter-spacing: 2%;
    color: white;
    margin: 0;

}

/* Bottom nav bar */

/* App bar */

.app-bar {
    display: flex;
    position: absolute;
    left: 6.977vw;
    top: 3.488vw;
    width: 86.512vw;
    border-radius: 9.767vw;
    border: 1px solid #FFFFFF1C;
    backdrop-filter: blur(59px);
    background-color: #49B2FF0D;
    align-items: center;
}

.app-bar .user-image {
    border: 1px solid #E64DFF;
    width: 8.837vw;
    height: 8.837vw;
    object-fit: cover;
    border-radius: 50%;
    margin: 3vw;
}

.app-bar .info {
   display: flex;
   flex-direction: column;
}

.app-bar .info h2 {
    margin: 0;
    font-weight: 600;
    font-size: 3.721vw;
    line-height: 4.419vw;
    letter-spacing: 2%;
    color: #FFFFFF;
}

.app-bar .info h3 {
    margin: 0;
    font-weight: 600;
    font-size: 2.791vw;
    line-height: 3.488vw;
    letter-spacing: 2%;
    color: #FFFFFFB2;
}

/* App bar */

/* Bottom sheet */

.bottom-sheet {
    z-index: 200;
    --rsbs-bg: #242426;
    --rsbs-max-h: 90vh; 
    --rsbs-handle-bg: #242426;
}

.bottom-sheet .handle-icon-container {
    width: 100vw;
    display: flex;
    justify-content: center;
    padding-bottom: 2vw;
}

.bottom-sheet .handle-icon-container .handle-icon {
    transform: rotate(90deg);
    width: 5vw;
    height: 5vw;
}

.sheet-header {
  text-align: center;
  font-size: 4.186vw;
  font-weight: bold;
  margin-bottom: 3.488vw;
  color: white;
}

.task-list {
  padding-bottom: 30vw;
  padding-top: 10vw;
}

.task-list .link-button {
    margin-bottom: 3vw;
}

.task-list .link-button h4{
    color: white;
}

/* Bottom sheet */`, "",{"version":3,"sources":["webpack://./src/style/style.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;IACI,6BAA6B;IAC7B,+DAAgF;IAChF,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,+DAAkF;IAClF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,+DAAmF;IACnF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,0DAA4F;IAC5F,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,UAAU;;AAEV,eAAe;;AAEf;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;AAEA,eAAe;;AAEf,eAAe;;AAEf;EACE,uCAAuC;EACvC,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA,eAAe;;AAEf,mBAAmB;;AAEnB;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,SAAS;;AAEb;;AAEA,mBAAmB;;AAEnB,YAAY;;AAEZ;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,YAAY;;AAEZ,iBAAiB;;AAEjB;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA,iBAAiB","sourcesContent":["/* Fonts */\n\n@font-face {\n    font-family: \"SF Pro Display\";\n    src: url(\"../../public/assets/fonts/SF-Pro-Display-Bold.otf\") format(\"opentype\");\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"SF Pro Display\";\n    src: url(\"../../public/assets/fonts/SF-Pro-Display-Medium.otf\") format(\"opentype\");\n    font-weight: 600;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"SF Pro Display\";\n    src: url(\"../../public/assets/fonts/SF-Pro-Display-Regular.otf\") format(\"opentype\");\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: \"Roboto\";\n    src: url(\"../../public/assets/fonts/Roboto-Italic-VariableFont_wdth,wght.ttf\") format(\"ttf\");\n    font-weight: 500;\n    font-style: normal;\n}\n\n/* Fonts */\n\n/* Background */\n\n.background {\n    z-index: -1;\n    position: absolute;\n    width: 100vw;\n    height: 100vh;\n    object-fit: cover;\n}\n\n/* Background */\n\n/* Main style */\n\nbody, *{\n  font-family: SF Pro Display, sans-serif;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n#root {\n  max-height: 100vh;\n  overflow: hidden;\n}\n\n\n.default-page-setting {\n  width: 100vw;\n  height: 100vh;\n  padding-top: 18.5vw;\n  padding-bottom: 24vw;\n}\n\nh1 {\n    font-weight: 600;\n    font-size: 11.163vw;\n    line-height: 13.256vw;\n    text-align: center;\n    color: white;\n}\n\nh3 {\n    font-weight: 500;\n    font-size: 4.651vw;\n    line-height: 5.349vw;\n    letter-spacing: 2%;\n    color: #FFFFFF;\n}\n\nh4 {\n    font-weight: 300;\n    font-size: 3.721vw;\n    line-height: 4.186vw;\n    letter-spacing: 2%;\n    text-align: center;\n    color: #FFFFFF66;\n}\n\nh5 {\n    font-weight: 400;\n    font-size: 3.256vw;\n    line-height: 3.886vw;\n    letter-spacing: 2%;\n    color: #FFFFFF66;\n}\n\n.stars-counter {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.top-margin {\n    margin-top: 13.953vw;\n}\n\n/* Main style */\n\n/* Bottom nav bar */\n\n.bottom-nav-bar {\n    display: flex;\n    position: absolute;\n    left: 6.977vw;\n    bottom: 6.977vw;\n    width: 86.512vw;\n    border-radius: 16px;\n    border: 1px solid #FFFFFF1C;\n    backdrop-filter: blur(59px);\n    background-color: #49B2FF0D;\n}\n\n.bottom-nav-bar .navbar-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 28.837vw;\n    height: 16.977vw;\n    text-decoration: none\n}\n\n.bottom-nav-bar .navbar-item:nth-child(-n+2) {\n    border-right: 1px solid #FFFFFF1C;\n}\n\n.navbar-item .navbar-icon{\n    width: 6.512vw;\n    height: 6.512vw;\n    margin-bottom: 0.93vw;\n}\n\n.navbar-item p {\n    font-weight: 600;\n    font-size: 2.791vw;\n    line-height: 3.33vw;\n    letter-spacing: 2%;\n    color: white;\n    margin: 0;\n\n}\n\n/* Bottom nav bar */\n\n/* App bar */\n\n.app-bar {\n    display: flex;\n    position: absolute;\n    left: 6.977vw;\n    top: 3.488vw;\n    width: 86.512vw;\n    border-radius: 9.767vw;\n    border: 1px solid #FFFFFF1C;\n    backdrop-filter: blur(59px);\n    background-color: #49B2FF0D;\n    align-items: center;\n}\n\n.app-bar .user-image {\n    border: 1px solid #E64DFF;\n    width: 8.837vw;\n    height: 8.837vw;\n    object-fit: cover;\n    border-radius: 50%;\n    margin: 3vw;\n}\n\n.app-bar .info {\n   display: flex;\n   flex-direction: column;\n}\n\n.app-bar .info h2 {\n    margin: 0;\n    font-weight: 600;\n    font-size: 3.721vw;\n    line-height: 4.419vw;\n    letter-spacing: 2%;\n    color: #FFFFFF;\n}\n\n.app-bar .info h3 {\n    margin: 0;\n    font-weight: 600;\n    font-size: 2.791vw;\n    line-height: 3.488vw;\n    letter-spacing: 2%;\n    color: #FFFFFFB2;\n}\n\n/* App bar */\n\n/* Bottom sheet */\n\n.bottom-sheet {\n    z-index: 200;\n    --rsbs-bg: #242426;\n    --rsbs-max-h: 90vh; \n    --rsbs-handle-bg: #242426;\n}\n\n.bottom-sheet .handle-icon-container {\n    width: 100vw;\n    display: flex;\n    justify-content: center;\n    padding-bottom: 2vw;\n}\n\n.bottom-sheet .handle-icon-container .handle-icon {\n    transform: rotate(90deg);\n    width: 5vw;\n    height: 5vw;\n}\n\n.sheet-header {\n  text-align: center;\n  font-size: 4.186vw;\n  font-weight: bold;\n  margin-bottom: 3.488vw;\n  color: white;\n}\n\n.task-list {\n  padding-bottom: 30vw;\n  padding-top: 10vw;\n}\n\n.task-list .link-button {\n    margin-bottom: 3vw;\n}\n\n.task-list .link-button h4{\n    color: white;\n}\n\n/* Bottom sheet */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
